@import '../../styles/shared/status.css';

.eds-status-badge {
  align-items: center;
  border-radius: var(--eds--radii-full);
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  max-width: 240px;
  min-height: calc(
    var(--eds--typography--body-semi-s-line-height) + var(--eds--padding-2) +
      var(--eds--padding-4)
  );
  min-width: 0;
  overflow: hidden;
  padding: var(--eds--padding-2) var(--eds--padding-12) var(--eds--padding-4);
  width: fit-content;
}

.eds-status-badge .eds-tooltip--trigger {
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  width: 100%;
}
